import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import { connect } from 'react-redux'
import { userSignOut } from '../../actions/Auth';
import stancebeamIcon from '../../assets/images/icons/stancebeam-icon.svg'

class UserInfo extends React.Component {

  constructor() {
    super()
    this.state = {
      anchorEl: null,
      open: false,
      displayName: "",
      profileIcon: stancebeamIcon//(((JSON.parse(localStorage.getItem('players'))).profilePic) === undefined) ? stancebeamIcon : (JSON.parse(localStorage.getItem('players'))).profilePic.url,
    };
  }

  componentDidMount() {
    this.setState({
      displayName: this.props.auth.hasOwnProperty("authUser") ? (this.props.auth.authUser.hasOwnProperty("fullName") ? this.props.auth.authUser.fullName : "") : ""
    })
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        <Avatar
          alt='...'
          src={this.state.profileIcon}
          className="user-avatar "
        />
        <div className="user-detail">
          <h4 className="user-name">{this.state.displayName} <i
            className="zmdi zmdi-hc-fw align-middle" />
          </h4>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale } = settings;
  return { locale, auth }
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);


